module.exports = __webpack_public_path__ + "img/icon_tianjia.191de01e.svg";